import {
  Container,
  Stack,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getAllHealth } from "../../../api";
import { DataGrid } from "@mui/x-data-grid";
import { grid_columns } from "../utils";
import moment from "moment/moment";

export default function AllHealth() {
  const navigate = useNavigate();
  const [healthData, setHealthData] = useState();
  const [rows, setRows] = useState([]);
  const [columnsEdited, setColumnsEdited] = useState([]);
  const [isloading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAllHealth();
        setHealthData(result);
        setIsLoading(false);
      } catch (error) {}
    };
    fetchData();
  }, []);

  useEffect(() => {
    let table_rows = [];
    if (healthData?.length > 0) {
      healthData?.map((health) => {
        let row = {
          id: health?.id,
          title:
            health?.title === null || health?.title === "" ? "-" : health.title,
          description: health?.description,
          updated_at:
            health?.updated_at !== null
              ? moment(health.updated_at).format("DD/MM/YYYY")
              : "-",
          is_deleted: health?.is_deleted,
        };
        return table_rows.push(row);
      });
    }

    setRows(table_rows);
  }, [healthData]);

  useEffect(() => {
    let columns_array = [...grid_columns];
    let itemName = grid_columns?.filter(
      (element) => element?.field === "title"
    )[0];

    let indexName = columns_array?.indexOf(itemName);

    itemName = {
      ...itemName,
      renderCell: (params) => (
        <Box
          sx={{ cursor: "pointer", "&:hover": { color: "primary.main" } }}
          onClick={() => handleNavigate(params?.row?.id)}
        >
          {params?.row?.title}
        </Box>
      ),
    };

    columns_array[indexName] = itemName;

    setColumnsEdited(columns_array);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const handleNavigate = (id) => {
    navigate("/health/edit-health", {
      state: {
        healthId: id,
      },
    });
  };

  return (
    <Container>
      <Stack
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "100%", sm: "100%" },
        }}
      >
        <Card>
          <CardContent>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={5}
            >
              <Typography variant="h4">Health</Typography>

              <Button
                variant="contained"
                color="primary"
                style={{
                  fontSize: "14px",
                  fontFamily: "sans-serif",
                  fontWeight: 700,
                  textTransform: "initial",
                }}
                startIcon={<AddIcon />}
                onClick={() => navigate("/health/create-new")}
              >
                New
              </Button>
            </Stack>

            <DataGrid
              rows={rows}
              columns={columnsEdited}
              loading={isloading}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              disableRowSelectionOnClick
              sx={{
                "& .MuiDataGrid-cellContent": {
                  whiteSpace: "break-spaces",
                  paddingY: 1,
                },
                "& .MuiDataGrid-columnHeaders": {
                  bgcolor: "background.neutral",
                  borderRadius: 0,
                  color: "text.secondary",
                },
                "& .MuiDataGrid-iconSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter":
                  {
                    display: "none",
                  },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus":
                  {
                    outline: "none !important",
                  },
                "& .MuiDataGrid-overlayWrapper": {
                  minHeight: "200px",
                },
              }}
            />
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
